import React, { useState, useEffect } from "react";
import { MdLocationOn } from "react-icons/md";
import { Calendar, ArrowRight, Sparkles } from "lucide-react";

// Assuming these paths match your project structure
import img1 from "../Event/E-summit.png";
import img2 from "../../global-images/bg-2.jpg";
import img7 from "../ProgramImages/1.png";
import img8 from "../ProgramImages/3.png";
import img9 from "../ProgramImages/4.png";
import img10 from "../ProgramImages/5.png";
import img11 from "../ProgramImages/6.png";
import img12 from "../ProgramImages/7.png";
import img13 from "../ProgramImages/12.jpg";
import img14 from "../ProgramImages/13.jpg";
import img15 from "../ProgramImages/14.jpg";
import img16 from "../ProgramImages/15.jpg";
import img17 from "../ProgramImages/16.jpg";
import img18 from "../ProgramImages/17.jpg";
import img19 from "../ProgramImages/18.jpg";

function Events() {
  // State to trigger entry animations
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Trigger the animation shortly after the component mounts
    const timer = setTimeout(() => setIsLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  // Main Flagship Event
  const mainEvent = {
    src: img1, // Replace with actual main E-summit poster
    title: "E-SUMMIT '26",
    subtitle: "Pioneering the Impossible",
    description:
      "The flagship event of E-Cell IIT Ropar, bringing together students, entrepreneurs, investors, and industry experts. Join us for 15+ events, 6+ zones, and an expected footfall of 50K+ to promote innovation and entrepreneurial thinking.",
    Venue: "IIT Ropar Campus",
    Date: "11th - 12th April 2026",
  };

  // Sub-events under the E-Summit
  const subEvents = [
    {
      src: img2,
      title: "Internship Fair",
      description:
        "Explore career opportunities with top startups and companies offering openings in technical, management, and creative roles to support early career growth.",
      Venue: "IIT Ropar Campus",
      Date: "Coming Soon",
      hasRegistration: true, 
      registrationLink: "https://docs.google.com/forms/d/e/1FAIpQLSfr_cxypOJGUaWo6P-B0SOjvG6oHGr0ST5kCR11rzKHhwMDlQ/viewform" // Add your actual Google Form link here
    },
  ];

  const pastEvents = [
    {
      img: img11,
      title: "",
      description: "",
    },
    {
      img: img10,
      title: "",
      description: "",
    },
    {
      img: img9,
      title: "",
      description: "",
    },
    {
      img: img8,
      title: "",
      description: "",
    },
    {
      img: img7,
      title: "",
      description: "",
    },
    {
      img: img12,
      title: "",
      description: "",
    },
    { img: img13, description: "" },
    { img: img14, description: "" },
    { img: img15, description: "" },
    { img: img16, description: "" },
    { img: img17, description: "" },
    { img: img18, description: "" },
    { img: img19, description: "" },
  ];

  return (
    <div className="bg-gray-50 min-h-screen font-sans pb-20 overflow-hidden">
      
      {/* Header Section */}
      <div className={`pt-24 pb-12 transition-all duration-1000 transform ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 -translate-y-5'}`}>
        <div className="text-center">
          <h2 className="text-4xl md:text-5xl font-extrabold text-gray-900 tracking-tight">
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">Upcoming</span> Events
          </h2>
          <div className="w-24 h-1.5 bg-gradient-to-r from-blue-600 to-indigo-600 mx-auto mt-4 rounded-full"></div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Main Flagship Event Hero Card - Redesigned without black background */}
        <div 
          className={`bg-white rounded-[2.5rem] shadow-[0_8px_30px_rgb(0,0,0,0.08)] border border-gray-100 overflow-hidden flex flex-col lg:flex-row items-center mb-16 transition-all duration-1000 delay-150 transform ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-12'}`}
        >
          {/* Left Side: Front Image */}
          <div className="w-full lg:w-1/2 p-6 md:p-10 relative group perspective-1000">
            {/* Decorative background blob behind image */}
            <div className="absolute inset-0 bg-gradient-to-tr from-blue-100 to-indigo-50 transform scale-90 rounded-[3rem] opacity-50 group-hover:scale-100 transition-transform duration-700 ease-out z-0"></div>
            
            <img
              src={mainEvent.src}
              alt={mainEvent.title}
              className="relative z-10 w-full h-auto object-cover rounded-3xl shadow-lg transform group-hover:-translate-y-2 group-hover:shadow-2xl transition-all duration-500 border border-white/50"
            />
          </div>

          {/* Right Side: Text & Content */}
          <div className="w-full lg:w-1/2 p-6 md:p-10 lg:pr-16 flex flex-col justify-center space-y-6">
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-blue-50 border border-blue-100 rounded-full w-max shadow-sm">
              <Sparkles className="w-4 h-4 text-blue-600" />
              <span className="text-sm font-bold tracking-widest text-blue-700 uppercase">
                Flagship Event
              </span>
            </div>
            
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold leading-tight text-gray-900 tracking-tight">
              {mainEvent.title}
              <span className="block text-2xl md:text-3xl lg:text-4xl mt-2 text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-indigo-600">
                {mainEvent.subtitle}
              </span>
            </h1>

            <p className="text-lg text-gray-600 leading-relaxed">
              {mainEvent.description}
            </p>

            {/* Quick Info Tags */}
            <div className="flex flex-wrap gap-4 pt-2">
              <div className="flex items-center gap-2 bg-gray-50 px-4 py-2.5 rounded-xl border border-gray-200 text-gray-700 font-medium">
                <Calendar className="w-5 h-5 text-blue-500" />
                <span>{mainEvent.Date}</span>
              </div>
              <div className="flex items-center gap-2 bg-gray-50 px-4 py-2.5 rounded-xl border border-gray-200 text-gray-700 font-medium">
                <MdLocationOn className="w-6 h-6 text-blue-500" />
                <span>{mainEvent.Venue}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Sub-Events Grid (Highlighted Events) */}
        <div className={`mb-16 transition-all duration-1000 delay-300 transform ${isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          <div className="flex items-center justify-between mb-8">
            <h3 className="text-2xl md:text-3xl font-bold text-gray-800">
              E-Summit Highlights
            </h3>
          </div>
          
          <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {subEvents.map((event, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 shadow-md border border-gray-100 hover:shadow-2xl hover:-translate-y-2 transition-all duration-300 flex flex-col h-full group">
                <div className="h-48 rounded-xl overflow-hidden mb-5">
                  <img src={event.src} alt={event.title} className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-700 ease-in-out" />
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-blue-600 transition-colors">{event.title}</h4>
                <p className="text-gray-600 text-sm flex-grow mb-5 line-clamp-3">
                  {event.description}
                </p>
                <div className="space-y-2 mt-auto pt-4 border-t border-gray-100">
                  <div className="flex items-center text-sm text-gray-700">
                    <Calendar className="w-4 h-4 text-blue-500 mr-2" />
                    <span>{event.Date}</span>
                  </div>
                  <div className="flex items-center text-sm text-gray-700">
                    <MdLocationOn className="w-4 h-4 text-blue-500 mr-2" />
                    <span className="truncate">{event.Venue}</span>
                  </div>
                </div>
                
                {/* Render button conditionally based on hasRegistration flag */}
                {event.hasRegistration && (
                  <a 
                    href={event.registrationLink || "#"} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="mt-5 w-full flex items-center justify-center gap-2 py-3 bg-blue-600 hover:bg-blue-700 text-white font-semibold rounded-xl transition-all shadow-[0_4px_14px_0_rgba(37,99,235,0.39)] hover:shadow-[0_6px_20px_rgba(37,99,235,0.23)] hover:-translate-y-1"
                  >
                    Register Now <ArrowRight className="w-4 h-4" />
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Past Events Section */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-12 border-t border-gray-200 pt-16">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 tracking-tight">
            <span className="text-blue-600">Past</span> Events
          </h2>
          <div className="w-16 h-1 bg-blue-600 mx-auto mt-4 rounded-full"></div>
        </div>

        <div className="grid gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {pastEvents.map((event, index) => (
            <div
              key={index}
              className="group relative cursor-pointer bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl hover:-translate-y-1 transition-all duration-300"
            >
              <div className="aspect-w-4 aspect-h-3 h-64 overflow-hidden bg-gray-200">
                <img
                  src={event.img}
                  alt={event.title || `Past Event ${index + 1}`}
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
                />
              </div>
              
              <div className="absolute inset-0 bg-gradient-to-t from-gray-900 via-gray-900/60 to-transparent opacity-80 group-hover:opacity-90 transition-opacity duration-300"></div>
              
              <div className="absolute inset-0 flex flex-col justify-end p-6 translate-y-4 group-hover:translate-y-0 transition-transform duration-300">
                {event.title && (
                  <h3 className="text-xl font-bold text-white mb-2 leading-tight">
                    {event.title}
                  </h3>
                )}
                {event.description && (
                  <p className="text-sm text-gray-300 line-clamp-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 delay-100">
                    {event.description}
                  </p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Events;